<!-- 门店明细--项目订单列表 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="store" suffix-icon="el-icon-search" placeholder="搜索门店" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="projectName" suffix-icon="el-icon-search" placeholder="搜索项目名称" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="orderNum" suffix-icon="el-icon-search" placeholder="搜索订单编号" clearable
        @change="onSearch"></el-input>
      <el-select v-model="payType" placeholder="选择支付方式" @change="onSearch" clearable>
        <el-option v-for="item in payTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="type" placeholder="选择结算类型" @change="onSearch" clearable>
        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-date-picker v-model="dateTime" type="daterange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" clearable @change="handleSelectData" value-format="yyyy-MM-dd"></el-date-picker>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="storeName" label="门店"></el-table-column>
        <el-table-column min-width="140" show-overflow-tooltip prop="orderNum" label="订单编号"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="bizName" label="项目名称"></el-table-column>
        <el-table-column min-width="100" prop="payType" label="支付方式" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>
              {{ getOrderTypeText(scope.row.payType) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="110" show-overflow-tooltip prop="settlementType" label="结算类型">
          <template slot-scope="scope">
            <span v-if="scope.row.settlementType == 1">销售</span>
            <span v-if="scope.row.settlementType == 2">退货</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="orderAmount" label="订单金额（元）"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="payAmount" label="支付金额（元）"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="settlementAmount"
          label="结算金额（元）"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="订单时间"></el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      store: "", // 门店
      projectName: "", // 项目名称
      orderNum: "", // 订单编号
      type: "", // 结算类型
      typeOptions: [{
        value: "1",
        label: "销售",
      },
      {
        value: "2",
        label: "退货",
      },
      ],
      payType: "",
      payTypeOptions: [{
        value: "2",
        label: "现金支付",
      },
      {
        value: "1",
        label: "线上支付",
      },
      {
        value: "3",
        label: "会员卡支付",
      },
      ],
      dateTime: [], // 时间区间
      tableData: [], // 表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getStoreSettlementList()
  },

  methods: {
    // 获取列表
    getStoreSettlementList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        projectName: this.projectName || null,  // 项目名称
        orderNum: this.orderNum || null,  // 订单编号
        payType: this.payType || null,   // 支付方式
        settlementType: this.type || null,  // 结算类型
        orderSource: 2,  // 服务列表传1 项目列表传2
      }
      // 时间区间
      if (this.dateTime && this.dateTime.length === 2) {
        params.startTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      } else {
        params.startTime = null
        params.endTime = null
      }
      this.$axios
        .get(this.$api.getStoreSettlementList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    onSearch() {
      this.clearData()
      this.getStoreSettlementList()
    },
    // 时间搜索
    handleSelectData(value) {
      this.dateTime = value
      this.onSearch()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getStoreSettlementList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getStoreSettlementList()
    },
    // 支付类型
    getOrderTypeText(status) {
      switch (String(status)) {
        case "1":
          return "线上支付"
        case "2":
          return "现金支付"
        case "3":
          return "会员卡支付"
        default:
          return ""
      }
    },
  },
}
</script>

<style scoped lang="scss">
.main {}
</style>
